const routes = [
    //石油苯
    {
        path: 'oilBenzene',
        name: '石油苯',
        component: () => import('@/views/oilBenzene/index'),
    },
    {
        path: 'oilBenzene/twoPage/industry',
        name: '石油苯行业动态二级页',
        component: () => import('@/views/oilBenzene/twoPage/industry')
    },
    {
        path: 'oilBenzene/industry',
        name: '石油苯行业动态详情页',
        component: () => import('@/views/oilBenzene/detail/industry')
    },
    {
        path: 'oilBenzene/twoPage/price',
        name: '石油苯价格二级页',
        component: () => import('@/views/oilBenzene/twoPage/price')
    },
    {
        path: 'oilBenzene/price',
        name: '石油苯价格详情页',
        component: () => import('@/views/oilBenzene/detail/priceIndex')
    },
    {
        path: 'oilBenzene/twoPage/enterprise',
        name: '石油苯重点企业资讯二级页',
        component: () => import('@/views/oilBenzene/twoPage/enterprise')
    },
    {
        path: 'oilBenzene/enterprise',
        name: '石油苯重点企业资讯详情页',
        component: () => import('@/views/oilBenzene/detail/enterprise')
    },
    {
        path: 'oilBenzene/twoPage/report',
        name: '石油苯研究报告二级页',
        component: () => import('@/views/oilBenzene/twoPage/report')
    },
    {
        path: 'oilBenzene/twoPage/yield',
        name: '石油苯产量二级页',
        component: () => import('@/views/oilBenzene/twoPage/yield')
    },
    {
        path: 'oilBenzene/yield',
        name: '石油苯产量详情页',
        component: () => import('@/views/oilBenzene/detail/yield')
    },
    {
        path: 'oilBenzene/twoPage/stock',
        name: '石油苯库存二级页',
        component: () => import('@/views/oilBenzene/twoPage/stock')
    },
    {
        path: 'oilBenzene/stock',
        name: '石油苯库存详情页',
        component: () => import('@/views/oilBenzene/detail/stock')
    },
    {
        path: 'oilBenzene/twoPage/exit',
        name: '石油苯进出口量二级页',
        component: () => import('@/views/oilBenzene/twoPage/exit')
    },
    {
        path: 'oilBenzene/exit',
        name: '石油苯进出口量详情页',
        component: () => import('@/views/oilBenzene/detail/exit')
    },
    {
        path: 'oilBenzene/twoPage/productPrice',
        name: '石油苯相关产品价格二级页',
        component: () => import('@/views/oilBenzene/twoPage/productPrice')
    },
    {
        path: 'oilBenzene/productPrice',
        name: '石油苯相关产品价格详情页',
        component: () => import('@/views/oilBenzene/detail/productPrice')
    },
    {
        path: 'oilBenzene/productPriceContent',
        name: '石油苯相关产品价格详情页苯乙烯',
        component: () => import('@/views/oilBenzene/detail/productPriceContent')
    },
    {
        path: 'oilBenzene/backPrice',
        name: '石油苯后两个价格详情页',
        component: () => import('@/views/oilBenzene/detail/backPrice')
    },
    {
        path: 'oilBenzene/twoPage/device',
        name: '石油苯装置动态二级页',
        component: () => import('@/views/oilBenzene/twoPage/device')
    },
    {
        path: 'oilBenzene/device',
        name: '石油苯装置动态详情页',
        component: () => import('@/views/oilBenzene/detail/device')
    },
    {
        path: 'oilBenzene/twoPage/standard',
        name: '石油苯行业标准二级页',
        component: () => import('@/views/oilBenzene/twoPage/standard')
    },
    {
        path: 'oilBenzene/relatedProducts',
        name: '石油苯相关产品价格外部链接',
        component: () => import('@/views/oilBenzene/detail/relatedProducts.vue')
    },
    {
        path: 'oilBenzene/relatedProductsHua',
        name: '石油苯化工外部链接',
        component: () => import('@/views/oilBenzene/detail/relatedProductsHua.vue')
    },
    {
        path: 'oilBenzene/relatedProductsSummary',
        name: '石油苯化工客户监控汇总表',
        component: () => import('@/views/oilBenzene/detail/relatedProductsSummary.vue')
    },
    {
        path: 'oilBenzene/map',
        name: '石油苯地图',
        component: () => import('@/views/oilBenzene/detail/map.vue')
    },
    {
        path: 'oilBenzene/forecast',
        name: '石油苯价格预测详情页',
        component: () => import('@/views/oilBenzene/detail/forecast')
    },
    {
        path: 'oilBenzene/twoPage/forecast',
        name: '焦煤价格预测二级页',
        component: () => import('@/views/oilBenzene/twoPage/forecast')
    },
]
export default routes
